import { buildSectionSelector, normalizeSectionId, sectionRenderer } from '@theme/section-renderer';
import { requestIdleCallback, onDocumentReady } from '@theme/utilities';

/**
 * Hydrates a section using the Section Rendering API preserving states.
 * Only updates elements with data-hydration-key attribute. This ensures that non-targeted nodes do not have their markup/state updated unnecessarily.
 *
 * @param {string} sectionId - The section ID to hydrate
 * @param {URL} [url] - The URL to render the section from
 */
async function hydrateSection(sectionId, url) {
  const normalizedId = normalizeSectionId(sectionId);
  const section = document.getElementById(buildSectionSelector(normalizedId));

  if (!section || section.dataset.hydrated === 'true') {
    return;
  }

  await sectionRenderer.renderSection(normalizedId, { cache: false, url, mode: 'hydration' });

  section.dataset.hydrated = 'true';
}

/**
 * NervaraLab (16.10.2026): Automatische Hydration deaktiviert.
 * Sie lud nach jedem Seitenaufruf den kompletten Header (~186 KB) erneut, nur um
 * Aktiv-Markierungen im Menü zu aktualisieren, und überschrieb dabei die
 * Anpassungen aus nv-menu.js. Zum Wiederherstellen: NV_HYDRATE auf true setzen.
 *
 * @param {string} sectionId - The section ID to hydrate
 * @param {URL} [url] - The URL to render the section from
 */
const NV_HYDRATE = false;

export async function hydrate(sectionId, url) {
  if (!NV_HYDRATE) return;
  onDocumentReady(() => {
    requestIdleCallback(() => hydrateSection(sectionId, url));
  });
}
